import { Inject, Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { SafeTypePipe } from './safe-type.pipe';
import { CDN_CONFIG } from '../config/tokens.config';
import { SafeType } from '../enum/safe-type.enum';

@Pipe({
    name: 'baseUrlCdn',
})
export class BaseUrlCdnPipe implements PipeTransform {
    /**
     * Creates an instance of base url api pipe.
     * @param safeTypePipe SafeTypePipe
     * @param cdnCofing string
     */
    public constructor(
        private safeTypePipe: SafeTypePipe,
        @Inject(CDN_CONFIG) private readonly cdnCofing: string
    ) {
        //
    }
    /**
     * Transforms base url api pipe
     * @param value string
     * @param type SafeType
     * @returns SafeUrl
     */
    public transform(value: string, type?: SafeType): SafeUrl {
        if (value) {
            let path = `${this.cdnCofing}/${value}`;

            switch (type) {
                case SafeType.STYLE:
                    path = `url('${path}')`;
                    break;
            }

            return this.safeTypePipe.transform(
                path,
                type ? type : SafeType.URL
            );
        }

        return '';
    }
}
